export const soldeEuros = (carte) => {
  return (
    parseFloat(carte.attributes.solde_euro) +
    parseFloat(carte.attributes.solde_euro_suiv ?? 0)
  );
}